import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

// Timeout 5 minutes pour la sync (300 000 ms)
// La sync appelle l'API Atera pour chaque agent — avec 300+ agents ça peut prendre du temps
const SYNC_TIMEOUT = 300000;

/** Sync complète — companies + assets + tickets dans l'ordre */
export const syncAll = async () => {
  try {
    const res = await api.post("/atera/sync/all", {}, { timeout: SYNC_TIMEOUT });
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

/** Sync des entreprises uniquement */
export const syncCompanies = async () => {
  try {
    const res = await api.post("/atera/sync/companies", {}, { timeout: SYNC_TIMEOUT });
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

/** Sync des assets uniquement */
export const syncAssets = async () => {
  try {
    const res = await api.post("/atera/sync/assets", {}, { timeout: SYNC_TIMEOUT });
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

/** Sync des tickets uniquement */
export const syncTickets = async () => {
  try {
    const res = await api.post("/atera/sync/tickets", {}, { timeout: SYNC_TIMEOUT });
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

/** Déduction des heures facturables depuis les tickets Atera uniquement */
export const syncBillingHours = async () => {
  try {
    const res = await api.post("/atera/sync/billing-hours", {}, { timeout: SYNC_TIMEOUT });
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};